import React, { useEffect, useState, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import { ReceivingBank } from "../../../utils/constant";
import DatePicker from "react-datepicker";
import SingleSelectDropDown from "../../../layouts/SingleSelectDropDown";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { rowValidation } from "../../../utils/bulkbankpayment";
import { ToastContainer, toast } from "react-toastify";
import { axios_instance } from "../../../api/axios_instance.js";
import ModalWrapper from "../../../layouts/ModalWrapper";
import { format } from "date-fns";
import { convertToUTCFormat } from "../../../utils/format.js";

const AddRowModal = ({
  closeAddRowModal,
  addRowProps,
  openConfirmationModal,
  fetchListData,
  showAddRowModal,
}) => {
  const { bank, amount, date, loanId, bulk_payment_id, utr_narration, transaction_id } =
    addRowProps;

  const initialState = {
    bank,
    amount: "",
    date,
    loanId,
    utr_narration,
    transaction_id: transaction_id || "",
    receivingBanks: [],
    receivingBankLength: 0,
  };

  const [state, setState] = useState(initialState);
  const [receivingBankLength, setreceivingBankLength] = useState(0);
  const ref = useRef();

  useEffect(() => {
    if (showAddRowModal) {
      const isEdit = !!addRowProps?.loanId; // or any reliable field

      setState((prevState) => ({
        bank: isEdit ? addRowProps.bank : "",
        amount: isEdit ? addRowProps.amount : "",
        date: isEdit
          ? addRowProps.date
            ? convertToUTCFormat(
                new Date(addRowProps.date),
                "yyyy-MM-dd HH:mm:ss"
              )
            : ""
          : "",
        loanId: isEdit ? addRowProps.loanId : "",
        utr_narration: isEdit ? addRowProps.utr_narration : "",
        transaction_id: isEdit ? addRowProps.transaction_id : "",
        receivingBanks: prevState.receivingBanks,
      }));
    }
  }, [showAddRowModal, addRowProps]);

  const fetchReceivingBanks = useCallback(async () => {
    try {
      const response = await axios_instance({
        url: "/dts/getReceivingBanks",
        method: "GET",
      });
      const result = response.data;
      console.log(result.data);
      if (result.status === true) {
        setState((prevState) => ({
          ...prevState,
          receivingBanks: result.data,
        }));
        setreceivingBankLength(1);
      }
    } catch (error) {
      console.error("Error fetching receiving banks:", error);
      toast.error("Failed to load receiving banks");
    }
  }, [receivingBankLength]);

  useEffect(() => {
    if (showAddRowModal && receivingBankLength === 0) {
      fetchReceivingBanks();
    }
    return modalEventListener(ref, closeAddRowModal);
  }, [showAddRowModal, fetchReceivingBanks, closeAddRowModal]);

  const mergeDateWithCurrentTime = (selectedDate) => {
    if (!selectedDate) return null;

    if (typeof selectedDate === "string") {
      selectedDate = new Date(selectedDate);
    }

    const now = new Date();
    return new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate(),
      now.getHours(),
      now.getMinutes(),
      now.getSeconds()
    );
  };

  const formatDateForAPI = (dateObj) => {
    if (!dateObj) return "";
    const mergedDate = mergeDateWithCurrentTime(dateObj);
    return format(mergedDate, "yyyy-MM-dd HH:mm:ss"); // Backend expects this format
  };
  const addPaymentRow = async (isBulk) => {
    const validations = rowValidation(state);
    toast.dismiss();
    if (validations.error) {
      setState({ ...state });
      return toast.error(validations.message, { theme: "colored" });
    }

    setState({ ...state });
    try {
      const params = {
        receiving_bank: state.bank,
        bank_payment_amount: state.amount,
        bank_payment_date: formatDateForAPI(state.date),
        finance_lead_id: state.loanId,
        utr_narration: state.utr_narration,
        transaction_id: state.transaction_id,
        bulk_payment_id: bulk_payment_id ? bulk_payment_id : state.loanId,
      };
      if (!isBulk) {
        const result = await axios_instance({
          url: "/bulkbank/addRow",
          method: "POST",
          data: {
            ...params,
            action: "add_payment_row",
          },
        });

        if (result.status === 200) {
          const confirmationData = result.data.confirmationData;
          const message = result.data.message;
          openConfirmationModal(confirmationData, message, "add_payment_row");
        }
      } else {
        if (window.confirm("Are you sure to proceed")) {
          const result = await axios_instance({
            url: "/bulkbank/updateRow",
            method: "POST",
            data: {
              ...params,
              action: "update_payment_row",
            },
          });

          if (result.status === 200) {
            if (result.data.status) {
              await fetchListData(false, true);
              toast(
                <>
                  <span className="glyphicon glyphicon-ok-sign"></span>
                  Payment row updated successfully
                </>
              );
            } else {
              toast.error("No record found", { theme: "colored" });
            }
          }
        }
      }
    } catch (error) {
      toast.error(
        error?.reponse?.data?.message
          ? error.reponse.data.message
          : "Something went wrong",
        { theme: "colored" }
      );
    }
  };

  return ReactDOM.createPortal(
    <ModalWrapper show={showAddRowModal} onClose={closeAddRowModal}>
      <div className="modal-wrapper">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div className="addrow-modal-content" ref={ref}>
          <input type="hidden" id="bulk_payment_id" value="" />
          <div className="modal-header">
            <button type="button" className="close" onClick={closeAddRowModal}>
              <span>&times;</span>
            </button>
            <h4 className="modal-title" id="">
              Bulk Bank Payment Upload
            </h4>
          </div>
          <div className="add-row-frm">
            <div className="modal-body clearfix">
              <div className="clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      Receiving Bank <span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <SingleSelectDropDown
                      dataArr={
                        Array.isArray(state.receivingBanks)
                          ? state.receivingBanks
                          : []
                      }
                      handleChange={(e) =>
                        setState({ ...state, bank: e.target.value })
                      }
                      name="receiving_bank"
                      value={state.bank}
                      className={state.bankClass ? state.bankClass : ""}
                    />
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      Bulk Payment Amount <span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className={`form-control ${
                          state.amountClass ? state.amountClass : ""
                        }`}
                        name="bank_payment_amount"
                        id="bank_payment_amount"
                        value={state.amount}
                        placeholder="Enter Amount"
                        onChange={(e) =>
                          setState({ ...state, amount: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      Bulk Payment Date <span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <div className="input-append date" id="dp-bank-summary">
                      <DatePicker
                        selected={state.date ? new Date(state.date) : ""}
                        onChange={(date, e) => {
                          setState({ ...state, date });
                          e.stopPropagation();
                        }}
                        maxDate={new Date()}
                        placeholderText="Select Date"
                        className={`span2 form-control add-on calender filter-tb date-bg_input ${
                          state.dateClass ? state.dateClass : ""
                        }`}
                        dateFormat="dd-MM-yyyy"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">Loan ID</label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className={`form-control ${
                        state.loanIdClass ? state.loanIdClass : ""
                      }}`}
                      value={state.loanId}
                      id="row_loan_id"
                      name="row_loan_id"
                      placeholder="Enter Loan ID"
                      onChange={(e) => {
                        setState({ ...state, loanId: e.target.value });
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      UTR/Narration<span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className={`form-control ${
                        state.utrNarrationClass ? state.utrNarrationClass : ""
                      }`}
                      name="bank_payment_utr_narration"
                      id="bank_payment_utr_narration"
                      value={state.utr_narration}
                      placeholder="Enter UTR/Narration"
                      onChange={(e) =>
                        setState({ ...state, utr_narration: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="form-group clearfix">
                <div className="row">
                  <div className="col-md-5 text-right">
                    <label className="fnt14">
                      Transaction ID<span className="col-red">*</span>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className={`form-control ${
                        state.transactionIdClass ? state.transactionIdClass : ""
                      }`}
                      name="bank_payment_transaction_id"
                      id="bank_payment_transaction_id"
                      value={state.transaction_id}
                      placeholder="Enter Transaction ID"
                      onChange={(e) =>
                        setState({ ...state, transaction_id: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer text-center">
            <button
              type="button"
              className="btn rc-btn_rset pad-L20 pad-R20"
              onClick={closeAddRowModal}
            >
              Cancel
            </button>
            <button
              type="button"
              id="saveRowBtn"
              className="btn rc-btn_primary btn-lg"
              onClick={() => addPaymentRow(loanId)}
            >
              {loanId ? "Save" : "Fetch"}
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default AddRowModal;
